import(/* webpackMode: "eager" */ "/workspace/src/app/auth/page.tsx");
